module.exports = {"title":"Save and publish my event","description":"<p>Submitting your event is FREE. Your event will now be made active and sales will begin based on your Start Dates. <br /><br />By clicking Save and Publish, you accept the terms and conditions of the <a href=\"/privacy-policy\" target=\"_blank\">PRIVACY POLICY</a> and <a href=\"/terms\" target=\"_blank\">TERMS AND CONDITIONS</a>.</p>","draftButton":"Keep it as draft","saveButton":"Save and Publish"}


//////////////////
// WEBPACK FOOTER
// ./src/components/SavePublishEvent/locales/fr.json
// module id = 1736
// module chunks = 0